import script from "./UDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./UDropdown.vue?vue&type=style&index=0&id=5477dca0&lang=css"

const __exports__ = script;

export default __exports__